var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStod2 = function SvgStod2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stod2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.681C0 6.203 5.217.957 11.667.957h179.869c4.986 0 7.145 3.188 2.015 4.666-29.537 8.087-47.363 26.087-57.015 38.725-6.985 9.42-17.464 27.695-22.869 37.362-1.913 3.55-2.392 5.623 2.971 2.884l1.159-.608c11.275-5.856 33.131-16.682 52.681-23.276 28.768-9.696 33.841 9.391 26.247 22.261-5.957 10.087-70.319 100.145-97.913 138.667-3.45 4.782-4.783 5.405-11.493 5.405H11.667C5.232 227.043 0 221.797 0 215.333V12.681ZM245.188.957h143.16c6.435 0 11.666 5.246 11.666 11.724v202.652c0 6.464-5.217 11.71-11.666 11.71H254.377c-5.855 0-6.276-1.666-2.478-7.072l27.202-38.507.653-.971c5.797-8.305 3.347-10.71-6.348-10.71H212.42c-3.652 0-6.116-1.522-2.463-7.189 11.55-17.942 41.71-65.116 56.594-91.29C281.899 44.32 268.71 15 245.986 5.03l-.827-.362c-2.594-1.116-2.782-3.71.029-3.71Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stod2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .957)",
    d: "M0 0h400v226.087H0z"
  })))));
};
export default SvgStod2;